import { BaseService } from 'core/services';
import ImportValidationRouteService from './ImportValidationRouteService';

class ImportValidationService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ImportValidationRouteService());
    }

    bulkUpdate(resources) {
        const url = this.routeService.bulkUpdate(resources);
        return this.apiClient.put(url, resources)
    }

}

export default ImportValidationService;
